import React, {useState, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Link } from 'react-router-dom';

import "../PaginaCustomer.css";
import "../content-styles.css"

import Swal from 'sweetalert2'

import * as Hosts from '../../../Hosts';
import {
	reqGET,
    reqPOST,
    reqPUT,
    functionSendMail

} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import Loader from '../../../loader'

import Navbar from "../Navbar/Navbar_00";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import Footer from "../Footer/Footer_00";

import { language } from './Language';

export default function Perfil(props) {
    const [, set_dados] = useState(null);
    const clients_list = useRef(null);
    const is_logged_in = useRef(null);

    const user_info = useRef({});
      
    const [dados_config, set_dados_config] = useState({});
    const [dados_navbar, set_dados_navbar] = useState({});

	const [isloading, setLoading] = useState(true)
    const [loading_table, /*set_loading_table*/] = useState(false);
    const [show_client_profile, set_show_client_profile] = useState(false);

    const [lang, set_lang] = useState('pt');
    
    useEffect(() => {

        (async () => {
            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(is_logged_in.current) {
                if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                    set_dados_navbar(props.dados_navbar)
                }
            }

            if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                set_dados_config(props.dados_config)
            }

            let getClients = async () => {

                let res_c = await reqGET(`${Hosts.SIMCore_API}/entities/${Hosts.companycode}/${token_info.user_info.id}`)
                if(res_c.data !== undefined && res_c.data !== null && res_c.data.length === 1) {

                    if(res_c.data[0].info?.permission_profile !== undefined && res_c.data[0].info?.permission_profile === true) {
                        set_show_client_profile(true)
                    }

                }

                return await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Cliente`)
                    .then(res => {

                        set_dados(clients_list.current = res.data)
                        setLoading(false)
                    })
                    .catch(erro => console.log(erro))
            }
            if (token_info !== undefined && token_info !== null && token_info.user_info !== undefined && token_info.user_info !== null && token_info.user_info.id !== '') {
                getClients()
            }
        })()

        if(localStorage.getItem('lang') !== undefined  || localStorage.getItem('lang') !== null) {
            set_lang(localStorage.getItem('lang'))
        }

    }, [props]);

    const send_notification = async (id_user) => {

        const { value: formValues } = await Swal.fire({
            title: "",
            html: "" +
                '<div class="my-3">' +
                    '<h4>' + language[lang].notifications_send + '</h4>' + 
                '</div>' +
                '<div class="form-group text-start">' +
                    '<label class="form-label">' + language[lang].field_title + '</label>' +
                    '<input id="swal-input1" type="text" class="form-control bg-color-gray-light" />' +
                "</div>" +
                '<div class="form-group text-start mt-3">' +
                    '<label class="form-label">' + language[lang].field_message + '</label>' +
                    '<textarea id="swal-input2" type="password" class="form-control bg-color-gray-light"></textarea>' +
                "</div>" +
            "",
            confirmButtonColor: "var(--primary)",
            confirmButtonText: "" + language[lang].btn_send + "",
            focusConfirm: false,
            showCloseButton: true,
            preConfirm: () => {
                return [
                    document.getElementById("swal-input1").value,
                    document.getElementById("swal-input2").value
                ];
            }
        });
        
        if (formValues) {
            if(formValues[0] !== '' & formValues[1] !== '') {
                let today = new Date();
                let today_aux = String(today.getDate()).padStart(2, '0') + '-' + String(today.getMonth() + 1).padStart(2, '0') + '-' + today.getFullYear();

                let notification_aux = {
                    id: '',
                    info: {
                        companycode: Hosts.companycode,
                        id_user: id_user,
                        date: today,
                        read_date: '',
                        title: formValues[0],
                        message: formValues[1],
                        order: 0,
                        state: '0',
                        type: 'notification'
                    }
                }

                await reqPOST(Hosts.SIMCore_API + '/web/client/notification', notification_aux) 

                let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +'; border:1px solid transparent; border-collapse:collapse;">' +
                    '<tr style="border-collapse: collapse;">' +
                        '<td align="left" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>' +
                                '<span><b>' + language[lang].notification + '</b></span>' +
                            '</div>' +
                        '</td>' + 
                        '<td align="right" style="padding: 30px 40px 0px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>'+ today_aux + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +

                    '<tr>' +
                        '<td colspan="2" align="right" style="height: 15px;"></td>' +
                    '</tr>' +

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                '<span>' + language[lang].notification_email_sent + '</span>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' + 

                    '<tr style="border-collapse: collapse;">' +
                        '<td colspan="2" align="left" style="padding:0px 40px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                            '<div>'+
                                language[lang].access_app_txt +  ' <a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">'+ language[lang].access_app_link +'</a>'+
                            '</div>'+
                        '</td>' +
                    '</tr>' +
                    
                    '<tr>' +
                        '<td colspan="2" align="right" style="height: 15px;"></td>' +
                    '</tr>' +
                '</table>'

                let sendFrom = Hosts.contactFrom
                let sendTo = [user_info.username]
                let sendToCC = ['web.dev@assec.pt']
                let subject = language[lang].subject_notification_email
                let content = mail_content
                let attachment = []

                await functionSendMail(sendFrom, sendTo, sendToCC, subject, content, attachment, dados_config)

                Swal.fire('', language[lang].notification_success, 'info')

            } else {
                Swal.fire('', language[lang].notification_warning, 'warning')
            }

        }

    }

    const aprove_client = async (el) => {

        el.info.ativo = true

        await reqPUT(`${Hosts.SIMCore_API}/entities`, el)

        let res = await reqGET(`${Hosts.SIMCore_API}/entities/special/${Hosts.companycode}/Cliente`)
        set_dados(clients_list.current = res.data)

        Swal.fire('', language[lang].client_aprove_success, 'info')

    }

    const contacts_client = (el) => {
        //console.log('el', el)


        let html_content = ''

        html_content += '' + 
            '<div>' +
                '<h4>' + language[lang].client_contacts + '</h4>' +
            '</div>' +
            '<div class="text-start mt-4">' +
                '<p>' +
                    '<small><strong>' + language[lang].field_name + ':</strong> ' + el.info.name + '</small>' +
                    '<br />' +
                    '<small><strong>' + language[lang].field_email + ':</strong> ' + el.contacts[0].email + '</small>' +
                    '<br />' +
                    '<small><strong>' + language[lang].dados_mobile_phone + ':</strong> ' + 
                        (el.contacts[0].phone !== undefined ? el.contacts[0].phone : (el.contacts[0].mobile_phone !== undefined ? el.contacts[0].mobile_phone : '')) + 
                    '</small>' +
                '</p>' +
            '</div>'

        if(el.contacts[0].person_responsables !== undefined) {

            html_content += '' + 
                '<div class="text-start mt-4">' +
                    '<h5><small>' + language[lang].responsable + '</small></h5>' +
                '</div>' 


            if(el.contacts[0].person_responsables[0] !== undefined && el.contacts[0].person_responsables[0] !== null) {
                
                html_content += '' + 
                    '<div class="text-start">' +
                        '<p>'

                if(el.contacts[0].person_responsables[0].name !== undefined && el.contacts[0].person_responsables[0].name !== null && el.contacts[0].person_responsables[0].name !== '') {
                    html_content += '' + 
                        '<small><strong>' + language[lang].field_name + ':</strong> ' + el.contacts[0].person_responsables[0].name + '</small>' +
                        '<br />'
                }
                if(el.contacts[0].person_responsables[0].email !== undefined && el.contacts[0].person_responsables[0].email !== null && el.contacts[0].person_responsables[0].email !== '') {
                    html_content += '' + 
                        '<small><strong>' + language[lang].field_email + ':</strong> ' + el.contacts[0].person_responsables[0].email + '</small>' +
                        '<br />'
                }
                if(el.contacts[0].person_responsables[0].mobile_phone !== undefined && el.contacts[0].person_responsables[0].mobile_phone !== null && el.contacts[0].person_responsables[0].mobile_phone !== '') {
                    html_content += '' + 
                        '<small><strong>' + language[lang].dados_mobile_phone + ':</strong> ' + el.contacts[0].person_responsables[0].mobile_phone + '</small>' +
                        '<br />'
                }

                html_content += '' + 
                        '</p>' +
                    '</div>'

            }

        }

        Swal.fire({
            title: '',
            icon: "",
            html: html_content,
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
          });

    }

    /*const show_notifications = (id_user) => {
        
    }

    const show_profile = () => {

    }*/

    const columns = [
        {
            name: language[lang].field_name,
            selector: 'info.name',
            sortable: true,
            left: true,
            maxWidth: '55%',
            minWidth: '250px',
        },
        {
            name: language[lang].client_actions,
            center: true,
            export: false,
            print: false,
            minWidth: '180px',
            maxWidth: '45%',
            cell: row => 
                row.info.ativo ?
                    <span>
                        {
                            show_client_profile ?
                                <Link className="btn btn-primary me-2 my-2" to={{ pathname: '/client/profile', state: { item: row.id } }} replace>
                                    {language[lang].client_profile}
                                </Link>
                            :
                                null
                        }
                        <Link className="btn btn-primary me-2 my-2" to={{ pathname: '/list/notifications', state: { item: row.id } }} replace>
                            {language[lang].client_notification_history}
                        </Link>
                        <button type="button" className='btn btn-primary me-2 my-2' onClick={() => send_notification(row.id) }>{language[lang].client_notify}</button>
                        <button type="button" className='btn btn-primary my-2' onClick={() => contacts_client(row) }>{language[lang].client_contacts}</button>
                    </span>
                :
                    <span>
                        <button type="button" className='btn btn-primary my-2' onClick={() => aprove_client(row) }>{language[lang].client_aprove}</button>
                    </span>
        },
    ]

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    }

    return (
        isloading ?
            <Loader />
        :

            <>
                <Navbar pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
                <Breadcrumb />
                <main className='client-list'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className='col-12 bg-light py-5'>
                                <div className='container'>
                                    <div className='row'>
                                        <div className='col-12 text-center'>
                                            <h3 className="titulo-primario">
                                                {language[lang].clients_list}
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container py-5">
                        <div className='row'>
                            <div className='col-12 mx-auto'>
                                <DataTable
                                    columns={columns}
                                    data={clients_list.current}
                                    noDataComponent={loading_table ? language[lang].table_loading : language[lang].table_empty}
                                    noHeader
                                    pagination
                                    exportHeaders
                                    paginationComponentOptions={defaultComponentOptions}
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 100]}
                                />
                            </div>
                        </div>

                    </div>
                </main>
                <Footer pag_welcome={true} dados_config={dados_config} dados_navbar={dados_navbar} />
            </>

    );
}